export enum OrderStatusFilter {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  CHECKED_OUT = 'CHECKED_OUT',
}

export enum RepositStatusFilter {
  ALL = 'ALL',
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  CHECKED_OUT = 'CHECKED_OUT',
  LET_ONLY = 'LET_ONLY',
  DELETED = 'DELETED',
}

export enum TenancyStatusFilter {
  ACTIVE = 'ACTIVE',
  CHECKED_OUT = 'CHECKED_OUT',
}

export enum RepositSort {
  END_DATE_DESCENDING = 'END_DATE_DESCENDING',
  END_DATE_ASCENDING = 'END_DATE_ASCENDING',
  START_DATE_DESCENDING = 'START_DATE_DESCENDING',
  START_DATE_ASCENDING = 'START_DATE_ASCENDING',
  CREATED_AT_DESCENDING = 'CREATED_AT_DESCENDING',
  CREATED_AT_ASCENDING = 'CREATED_AT_ASCENDING',
}

export enum LetOnlyFilter {
  ALL = 'ALL',
  YES = 'YES',
  NO = 'NO',
}

export interface RepositFilterOption {
  label: string;
  value: string;
  orderStatus: string;
  tenancyStatus: string;
  includeDeleted: boolean;
  onlyDeleted: boolean;
}

export const REPOSIT_ALL_FILTER_OPTION: RepositFilterOption = {
  label: 'All',
  value: RepositStatusFilter.ALL,
  orderStatus: '',
  tenancyStatus: '',
  includeDeleted: true,
  onlyDeleted: false,
};

export const REPOSIT_FILTER_OPTIONS: RepositFilterOption[] = [
  REPOSIT_ALL_FILTER_OPTION,
  {
    label: 'Draft',
    value: RepositStatusFilter.DRAFT,
    orderStatus: OrderStatusFilter.DRAFT,
    tenancyStatus: '',
    includeDeleted: false,
    onlyDeleted: false,
  },
  {
    label: 'Pending',
    value: RepositStatusFilter.PENDING,
    orderStatus: OrderStatusFilter.PENDING,
    tenancyStatus: '',
    includeDeleted: false,
    onlyDeleted: false,
  },
  {
    label: 'Active',
    value: RepositStatusFilter.ACTIVE,
    orderStatus: OrderStatusFilter.COMPLETE,
    tenancyStatus: TenancyStatusFilter.ACTIVE,
    includeDeleted: false,
    onlyDeleted: false,
  },
  {
    label: 'Checked Out',
    value: RepositStatusFilter.CHECKED_OUT,
    orderStatus: OrderStatusFilter.COMPLETE,
    tenancyStatus: TenancyStatusFilter.CHECKED_OUT,
    includeDeleted: false,
    onlyDeleted: false,
  },
  {
    label: 'Deleted',
    value: RepositStatusFilter.DELETED,
    orderStatus: '',
    tenancyStatus: '',
    includeDeleted: true,
    onlyDeleted: true,
  },
];

export const getRepositFilterUpdate = (option: RepositFilterOption) => ({
  filter: option.value,
  orderStatus: option.orderStatus,
  tenancyStatus: option.tenancyStatus,
  includeDeleted: option.includeDeleted,
  onlyDeleted: option.onlyDeleted,
});
